export default "__VITE_ASSET__7155cc0a__"